import React from 'react';
import {Modal, Button} from "react-bootstrap";

interface BackModalProps{
    show:boolean
    onHide: () => void
    onConfirm: () => void,
    modalTitle: string,
    modalBody: string,
    back: string,
    yes: string
}

export default class BackModal extends React.Component<BackModalProps> {
    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {this.props.modalTitle}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        {this.props.modalBody}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.onHide}>{this.props.back}</Button>
                    <Button onClick={this.props.onConfirm}>{this.props.yes}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}